import React, {useCallback, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useSearchParams} from 'react-router-dom';
import {getDataTable} from './getDataTable';
import {getAgainHandler, getDataRows, getFilter, getTotalCount} from '../../store/TableRedux/TableRedux';
import TableBox from './TableBox';

const CreatorTable = ({rowClassName,rowSelection,
                        childrenColumnName,rowKey,
                        expandable,listAddress,showPagination=true,clearData=true,
                        onDoubleClickRowHandler, columns,

                      }) => {
  const didMountRef = useRef(false);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const getAgain = useSelector((state) => state.TableRedux.getAgain);
  const loading = useSelector((state) => state.TableRedux.loading);
  const filter = useSelector((state) => state.TableRedux.filter);
  const dataRows = useSelector((state) => state.TableRedux.dataRows);
  const totalCount = useSelector((state) => state.TableRedux.totalCount);
  const stringifyFilter = JSON.stringify(filter);

  useEffect(() => {
    let params = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [k, v] of searchParams.entries()) {
      params = { ...params, [k]: v };
    }

    dispatch(getFilter({ ...params }));

  }, [searchParams,dispatch]);


  // const getData = ({ result, total }) => {
  //
  //   dispatch(getDataRows(result));
  //   dispatch(getTotalCount(total));
  //
  // };
  const getData = useCallback(({ result, total }) => {
    dispatch(getDataRows(result));
    dispatch(getTotalCount(total));
  }, [dispatch]);



  useEffect(() => {
    clearData && dispatch(getDataRows([]));
    if (didMountRef.current && listAddress) {

      getDataTable(listAddress, filter, dispatch, (data) => {
         getData(data);
      });
    } else {
      didMountRef.current = true;
    }
  }, [getAgain,dispatch, stringifyFilter,listAddress,getData,clearData]);

  useEffect(() => {
    const params = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    if (Object.keys(params)?.length > 0) {
      dispatch(getFilter({ ...params }));
    } else {
      dispatch(getFilter({}));
      dispatch(getAgainHandler());
    }

  }, [dispatch,searchParams]);

  return (<div>

    <TableBox rowKey={rowKey}  showPagination={showPagination} rowClassName={rowClassName} rowSelection={rowSelection} childrenColumnName={childrenColumnName} getFilter={getFilter} loading={loading} columns={columns}
              filter={filter} dataRows={dataRows}
              totalCount={totalCount}
              onDoubleClickRow={(row) => {
                // eslint-disable-next-line no-unused-expressions
                onDoubleClickRowHandler && onDoubleClickRowHandler(row);
              }}
              expandable={expandable}
    />
  </div>);
};

export default CreatorTable;